import { render, staticRenderFns } from "./SubscriptionUpsellCard.vue?vue&type=template&id=ac1948ea&scoped=true&"
import script from "./SubscriptionUpsellCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionUpsellCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionUpsellCard.vue?vue&type=style&index=0&id=ac1948ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1948ea",
  null
  
)

export default component.exports